import { render } from "./ListeSociete.vue?vue&type=template&id=36318527&ts=true"
import script from "./ListeSociete.vue?vue&type=script&lang=ts"
export * from "./ListeSociete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__